import { useMatomo } from "@jonkoops/matomo-tracker-react";
import React, { useEffect } from "react";

import { SwapTabs } from "../../components/SwapTabs/SwapTabs";
import { SwapLayout } from "./SwapLayout";

export const SwapView = () => {
  const { trackPageView } = useMatomo();

  useEffect(() => {
    trackPageView({
      documentTitle: "Swap",
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <SwapLayout>
      <SwapTabs />
    </SwapLayout>
  );
};

export default SwapView;
